import { DateTime } from "luxon";

// Dates and times follow the market of the clinic, not the device. Each is a
// default plus a single US exception, so opening a new market needs no change
// here:
//
//   date  day first, abbreviated month ("26 Jun 1999");  US "Jun 26, 1999"
//   time  24-hour ("16:00");                             US "4:00 PM"
//
// Matches Doctor UI's DATE_ABBR and TIME variants.
//
// The locale is pinned because luxon otherwise takes month and meridiem names
// from the device locale: the same DateTime renders "26 juni 1999" and
// "4:00 em" on a Swedish-configured iPad.
const LOCALE = "en-US";

// The single market test, so the US exception exists in one place rather than
// once per format. Compared case-insensitively: callers uppercase because the
// same value also keys the imperial-unit lookups in measurementConfig.ts, but a
// caller passing a raw "us" must not silently fall through to the default and
// hand a US clinic day-first dates on a 24-hour clock.
function isUS(countryCode: string | undefined): boolean {
  return countryCode?.toUpperCase() === "US";
}

export function formatDate(
  date: DateTime,
  countryCode: string | undefined
): string {
  const pinned = date.setLocale(LOCALE);
  return isUS(countryCode)
    ? pinned.toFormat("MMM d, yyyy")
    : pinned.toFormat("d MMM yyyy");
}

export function formatTime(
  date: DateTime,
  countryCode: string | undefined
): string {
  const pinned = date.setLocale(LOCALE);
  return isUS(countryCode)
    ? pinned.toFormat("h:mm a")
    : pinned.toFormat("HH:mm");
}

export function formatTimeRange(
  start: DateTime,
  end: DateTime,
  countryCode: string | undefined
): string {
  return `${formatTime(start, countryCode)} - ${formatTime(end, countryCode)}`;
}
